<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container px-0">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Basic Elements</h5>
                  </div>
                  <small class="text-truncate text-muted">Inputmask, Color Pickers, Tags Input</small>
                </div>
              </div>
            </div>
            <div class="col-7 col-xl-8 text-end">

            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container px-0">

          <div class="row clearfix">
            <div class="col-lg-12">
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Bootstrap Basic example</h6>
                </div>
                <div class="card-body">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">@</span>
                    </div>
                    <input type="text" class="form-control" placeholder="Username" aria-label="Username"
                      aria-describedby="basic-addon1">
                  </div>

                  <div class="input-group mb-3">
                    <input type="text" class="form-control" placeholder="Recipient's username"
                      aria-label="Recipient's username" aria-describedby="basic-addon2">
                    <div class="input-group-append">
                      <span class="input-group-text" id="basic-addon2">@example.com</span>
                    </div>
                  </div>

                  <label for="basic-url">Your vanity URL</label>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="basic-addon3">https://example.com/users/</span>
                    </div>
                    <input type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3">
                  </div>

                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">$</span>
                    </div>
                    <input type="text" class="form-control" aria-label="Amount (to the nearest dollar)">
                    <div class="input-group-append">
                      <span class="input-group-text">.00</span>
                    </div>
                  </div>

                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">With textarea</span>
                    </div>
                    <textarea class="form-control" aria-label="With textarea"></textarea>
                  </div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Custom form example</h6>
                </div>
                <div class="card-body">
                  <div class="form-group c_form_group">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">@</span>
                      </div>
                      <input type="text" class="form-control" placeholder="Username" aria-label="Username"
                        aria-describedby="basic-addon1">
                    </div>
                  </div>
                  <div class="form-group c_form_group">
                    <div class="input-group">
                      <input type="text" class="form-control" placeholder="Recipient's username"
                        aria-label="Recipient's username" aria-describedby="basic-addon2">
                      <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2">@example.com</span>
                      </div>
                    </div>
                  </div>

                  <div class="form-group c_form_group">
                    <label for="basic-url">Your vanity URL</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon3">https://example.com/users/</span>
                      </div>
                      <input type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3">
                    </div>
                  </div>

                  <div class="form-group c_form_group">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">$</span>
                      </div>
                      <input type="text" class="form-control" aria-label="Amount (to the nearest dollar)">
                      <div class="input-group-append">
                        <span class="input-group-text">.00</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group c_form_group">
                    <label>With textarea</label>
                    <div class="input-group">
                      <textarea class="form-control" aria-label="With textarea"></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Different Sizing</h6>
                </div>
                <div class="card-body">
                  <div class="input-group input-group-sm mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="inputGroup-sizing-sm">Small</span>
                    </div>
                    <input type="text" class="form-control" aria-label="Small" aria-describedby="inputGroup-sizing-sm">
                  </div>

                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="inputGroup-sizing-default">Default</span>
                    </div>
                    <input type="text" class="form-control" aria-label="Default"
                      aria-describedby="inputGroup-sizing-default">
                  </div>

                  <div class="input-group input-group-lg">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="inputGroup-sizing-lg">Large</span>
                    </div>
                    <input type="text" class="form-control" aria-label="Large" aria-describedby="inputGroup-sizing-sm">
                  </div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Input with Checkboxes and radios</h6>
                </div>
                <div class="card-body">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <input type="checkbox" aria-label="Checkbox for following text input">
                      </div>
                    </div>
                    <input type="text" class="form-control" aria-label="Text input with checkbox">
                  </div>

                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <input type="radio" aria-label="Radio button for following text input">
                      </div>
                    </div>
                    <input type="text" class="form-control" aria-label="Text input with radio button">
                  </div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Multiple addons</h6>
                  <small>Multiple add-ons are supported and can be mixed with checkbox and radio input versions.</small>
                </div>
                <div class="card-body">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">$</span>
                      <span class="input-group-text">0.00</span>
                    </div>
                    <input type="text" class="form-control" aria-label="Amount (to the nearest dollar)">
                  </div>

                  <div class="input-group">
                    <input type="text" class="form-control" aria-label="Amount (to the nearest dollar)">
                    <div class="input-group-append">
                      <span class="input-group-text">$</span>
                      <span class="input-group-text">0.00</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Custom Checkboxes and Radio Buttons</h6>
                </div>
                <div class="card-body">
                  <div class="row clearfix">
                    <div class="col-lg-6 col-md-12">
                      <label class="c_checkbox mb-2">
                        <input type="checkbox" checked>
                        <span class="checkmark"></span>
                        <span class="ms-2">Fancy Checkbox 1</span>
                      </label>
                      <label class="c_checkbox mb-2">
                        <input type="checkbox">
                        <span class="checkmark"></span>
                        <span class="ms-2">Fancy Checkbox 2</span>
                      </label>
                      <label class="c_checkbox mb-2">
                        <input type="checkbox">
                        <span class="checkmark"></span>
                        <span class="ms-2">Fancy Checkbox 3</span>
                      </label>
                    </div>
                    <div class="col-lg-6 col-md-12">
                      <div class="fancy-radio">
                        <label><input name="gender" value="male" type="radio" checked><span
                            class="ms-2"><i></i>Male</span></label>
                      </div>
                      <div class="fancy-radio">
                        <label><input name="gender" value="female" type="radio"><span
                            class="ms-2"><i></i>Female</span></label>
                      </div>
                      <br>
                      <label class="fancy-radio"><input name="gender2" value="male" type="radio"><span
                          class="ms-2"><i></i>Male</span></label>
                      <label class="fancy-radio"><input name="gender2" value="female" type="radio" checked><span
                          class="ms-2"><i></i>Female</span></label>
                      <br>
                      <label class="fancy-radio custom-color-green"><input name="gender3" value="male" type="radio"
                          checked><span class="ms-2"><i></i>Male</span></label>
                      <label class="fancy-radio custom-color-green"><input name="gender3" value="female"
                          type="radio"><span class="ms-2"><i></i>Female</span></label>
                      <br>
                      <label class="fancy-radio custom-color-green"><input name="gender4" value="male"
                          type="radio"><span class="ms-2"><i></i>Male</span></label>
                      <label class="fancy-radio custom-color-green"><input name="gender4" value="female" type="radio"
                          checked><span class="ms-2"><i></i>Female</span></label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Input Button addons</h6>
                </div>
                <div class="card-body">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <button class="btn btn-outline-secondary" type="button">Button</button>
                    </div>
                    <input type="text" class="form-control" placeholder="" aria-label=""
                      aria-describedby="basic-addon1">
                  </div>

                  <div class="input-group mb-3">
                    <input type="text" class="form-control" placeholder="Recipient's username"
                      aria-label="Recipient's username" aria-describedby="basic-addon2">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" type="button">Button</button>
                    </div>
                  </div>

                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <button class="btn btn-outline-secondary" type="button">Button</button>
                      <button class="btn btn-outline-secondary" type="button">Button</button>
                    </div>
                    <input type="text" class="form-control" placeholder="" aria-label=""
                      aria-describedby="basic-addon1">
                  </div>

                  <div class="input-group">
                    <input type="text" class="form-control" placeholder="Recipient's username"
                      aria-label="Recipient's username" aria-describedby="basic-addon2">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" type="button">Button</button>
                      <button class="btn btn-outline-secondary" type="button">Button</button>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <h6>Input Button dropdowns</h6>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend" dropdown>
                      <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="button-basic"
                        dropdownToggle type="button" aria-controls="dropdown-basic">Dropdown</button>
                      <div id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu"
                        aria-labelledby="button-basic">
                        <a class="dropdown-item" href="javascript:void(0);">Action</a>
                        <a class="dropdown-item" href="javascript:void(0);">Another action</a>
                        <a class="dropdown-item" href="javascript:void(0);">Something else here</a>
                        <div role="separator" class="dropdown-divider"></div>
                        <a class="dropdown-item" href="javascript:void(0);">Separated link</a>
                      </div>
                    </div>
                    <input type="text" class="form-control" aria-label="Text input with dropdown button">
                  </div>

                  <div class="input-group">
                    <input type="text" class="form-control" aria-label="Text input with dropdown button">
                    <div class="input-group-append" dropdown placement="bottom right">
                      <button class="btn btn-outline-secondary dropdown-toggle" id="button-alignment" dropdownToggle
                        type="button" aria-controls="dropdown-alignment">Dropdown</button>
                      <div d="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                        aria-labelledby="button-alignment">
                        <a class="dropdown-item" href="javascript:void(0);">Action</a>
                        <a class="dropdown-item" href="javascript:void(0);">Another action</a>
                        <a class="dropdown-item" href="javascript:void(0);">Something else here</a>
                        <div role="separator" class="dropdown-divider"></div>
                        <a class="dropdown-item" href="javascript:void(0);">Separated link</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <h6>Input Button wtih Segmented</h6>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend" dropdown>
                      <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="button-basic"
                        dropdownToggle type="button" aria-controls="dropdown-basic">Toggle Dropdown</button>
                      <div id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu"
                        aria-labelledby="button-basic">
                        <a class="dropdown-item" href="javascript:void(0);">Action</a>
                        <a class="dropdown-item" href="javascript:void(0);">Another action</a>
                        <a class="dropdown-item" href="javascript:void(0);">Something else here</a>
                        <div role="separator" class="dropdown-divider"></div>
                        <a class="dropdown-item" href="javascript:void(0);">Separated link</a>
                      </div>
                    </div>

                    <input type="text" class="form-control" aria-label="Text input with segmented dropdown button">
                  </div>

                  <div class="input-group">
                    <input type="text" class="form-control" aria-label="Text input with segmented dropdown button">
                    <div class="input-group-append" dropdown placement="bottom right">
                      <button class="btn btn-outline-secondary dropdown-toggle" id="button-alignment" dropdownToggle
                        type="button" aria-controls="dropdown-alignment">Dropdown</button>
                      <div d="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                        aria-labelledby="button-alignment">
                        <a class="dropdown-item" href="javascript:void(0);">Action</a>
                        <a class="dropdown-item" href="javascript:void(0);">Another action</a>
                        <a class="dropdown-item" href="javascript:void(0);">Something else here</a>
                        <div role="separator" class="dropdown-divider"></div>
                        <a class="dropdown-item" href="javascript:void(0);">Separated link</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Custom forms</h6>
                  <small>Input groups include support for custom selects and custom file inputs. Browser default
                    versions
                    of these are not supported.</small>
                </div>
                <div class="card-body">
                  <h6>1. Custom select</h6>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <label class="input-group-text" for="inputGroupSelect01">Options</label>
                    </div>
                    <select class="custom-select" id="inputGroupSelect01">
                      <option selected>Choose...</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                  </div>

                  <div class="input-group mb-3">
                    <select class="custom-select" id="inputGroupSelect02">
                      <option selected>Choose...</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                    <div class="input-group-append">
                      <label class="input-group-text" for="inputGroupSelect02">Options</label>
                    </div>
                  </div>

                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <button class="btn btn-outline-secondary" type="button">Button</button>
                    </div>
                    <select class="custom-select" id="inputGroupSelect03">
                      <option selected>Choose...</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                  </div>

                  <div class="input-group">
                    <select class="custom-select" id="inputGroupSelect04">
                      <option selected>Choose...</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" type="button">Button</button>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <h6>2. Custom file input</h6>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Upload</span>
                    </div>
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" id="inputGroupFile01">
                      <label class="custom-file-label" for="inputGroupFile01">Choose file</label>
                    </div>
                  </div>

                  <div class="input-group mb-3">
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" id="inputGroupFile02">
                      <label class="custom-file-label" for="inputGroupFile02">Choose file</label>
                    </div>
                    <div class="input-group-append">
                      <span class="input-group-text" id="">Upload</span>
                    </div>
                  </div>

                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <button class="btn btn-outline-secondary" type="button">Button</button>
                    </div>
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" id="inputGroupFile03">
                      <label class="custom-file-label" for="inputGroupFile03">Choose file</label>
                    </div>
                  </div>

                  <div class="input-group">
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" id="inputGroupFile04">
                      <label class="custom-file-label" for="inputGroupFile04">Choose file</label>
                    </div>
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" type="button">Button</button>
                    </div>
                  </div>
                </div>
              </div>



              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Datepicker & Date Range Picker</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-xs-12 col-12 col-md-4 form-group">
                      <input type="text" placeholder="Datepicker" class="form-control" bsDatepicker
                        [bsConfig]="{ isAnimated: true }">
                    </div>
                    <div class="col-xs-12 col-12 col-md-4 form-group">
                      <input type="text" placeholder="Daterangepicker" class="form-control" bsDaterangepicker
                        [bsConfig]="{ isAnimated: true }">
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Timepicker</h6>
                </div>
                <div class="card-body">
                  <timepicker [(ngModel)]="mytime"></timepicker>
                  <pre class="alert alert-info">Time is: {{mytime}}</pre>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Summernote</h6>
                </div>
                <div class="card-body">
                  <ckeditor [editor]="Editor" data=" Hello there,
                                                  <p>The toolbar can be customized and it also supports various callbacks such as
                                                      <code>oninit</code>, <code>onfocus</code>, <code>onpaste</code> and many more.</p>
                                                  <p>Please try <b>paste some texts</b> here</p>">
                  </ckeditor>
                </div>
              </div>
            </div>
          </div> <!-- .row end -->

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
